import { createContext } from "react";

const TestContext = createContext();

export default TestContext;
